import moment from 'moment'
export default {
  data() {
    return {
      donutChart: [],
      isAdmin: this.$store.getters['auth/isAdmin'],
      optionsCompanies: [],
      companyId: '',
      range: '---',
      search: '',
      masks: {
        input: 'DD/MM/YYYY',
      },
      indicators: [],
      acordeon: [
        {
          origin: 'domain',
          title: 'Domain',
          table: {
            fields: [
              { key: 'id', label: 'ID' },
              { key: 'primary', label: 'Domínio' },
              { key: 'lastscan', label: 'Último Scan' },
              { key: 'requestdate', label: 'Data de Requisição' },
              { key: 'status', label: 'Status' },
              { key: 'actions', label: 'Ações' },
            ],
            items: [],
            rows: 0,
          },
          isButton: true,
        },
        {
          origin: 'string',
          title: 'Strings',
          table: {
            fields: [
              { key: 'id', label: 'ID' },
              { key: 'searchstring', label: 'String de Busca' },
              { key: 'comments', label: 'Comentários' },
              { key: 'lastscan', label: 'Último Scan' },
              { key: 'requestdate', label: 'Data de Requisição' },
              { key: 'status', label: 'Status' },
              { key: 'actions', label: 'Ações' },
            ],
            items: [],
            rows: 0,
          },
          isButton: true,
        },
        {
          origin: 'vips',
          title: 'VIP',
          table: {
            fields: [
              { key: 'id', label: 'ID' },
              { key: 'company', label: 'Nome da empresa' },
              { key: 'name', label: 'Vip' },
              { key: 'status', label: 'Status' },
              { key: 'actions', label: 'Ações' },
            ],
            items: [],
            rows: 0,
          },
          isButton: true,
        },
        {
          origin: 'channels',
          title: 'Canais',
          table: {
            fields: [
              { key: 'searchstring', label: 'String Pesquisada' },
              { key: 'channelname', label: 'Nome do canal' },
              { key: 'amountfindings', label: 'Quantidade de Findings' },
              { key: 'channeltype', label: 'Tipo' },
              { key: 'actions', label: 'Ações' },
            ],
            items: [],
            rows: 0,
          },
        },
        {
          origin: 'leaks',
          title: 'Vazamentos',
          table: {
            fields: [
              { key: 'id', label: 'ID' },
              { key: 'primary', label: 'Nome' },
              { key: 'amountleaks', label: 'Total' },
              { key: 'lastseen', label: 'Última Identificação' },
              { key: 'actions', label: 'Ações' },
            ],
            items: [],
            rows: 0,
          },
        },
        // {
        //   origin: 'axur',
        //   title: 'AXUR',
        //   table: {
        //     fields: [
        //       { key: 'id', label: 'ID' },
        //       { key: 'company', label: 'Empresa' },
        //       { key: 'createdAt', label: 'Criado' },
        //       { key: 'status', label: 'Status' },
        //       { key: 'actions', label: 'Ações' },
        //     ],
        //     items: [],
        //     rows: 0,
        //   },
        // },
      ],
      statusArray: [],
    }
  },
  computed: {
    defaultDate() {
      return {
        start: moment(new Date()).subtract(15, 'days').format('DD/MM/YYYY'),
        end: moment(new Date()).format('DD/MM/YYYY'),
      }
    },
  },
}
